import React, { useRef, useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Form } from "react-bootstrap";
import { Formik } from "formik";

import { LoadingSpinner } from "../Shared";
import { MappixDesign } from "./";
import * as commonApi from "../../api/commonApi";
import { Common, CommonPages, DataType, MESSAGES, SessionStorageKeys } from "../../helper";
import { isEmptyObject, SessionStorage } from "../../util";
import { setEmail } from "../../store/loginSlice";

import "../../assets/stlyes/Common/LoginNew.scss";

import Account from "../../assets/images/IconAccount.png"
import HideVisibility from "../../assets/images/IconNotVisible1.png";
import ShowVisibility from "../../assets/images/IconVisible1.png";
import RightArrow from "../../assets/images/RightArrow.png";
import HexagonCharacter from "../../assets/images/HexagonCharacter.png";

const Login = () => {
  const navigate = useNavigate();
  const [btnImage, setBtnImage] = useState(HideVisibility);
  const emailRef = useRef(null);
  const [inputType, setInputType] = useState(DataType.Password)
  const [isLoading, setIsLoading] = useState(false);
  const passwordRef = useRef(null);
  const dispatch = useDispatch();

  const _userLogin = async (formData) => {
    setIsLoading(true);
    dispatch(setEmail(formData.email))
    const userLogin = await commonApi.userLogin(formData);
    setIsLoading(false);
    if (!(isEmptyObject(userLogin))) {
      if (userLogin.Items === MESSAGES.OTPSent) {
        navigate(CommonPages.authentication)
      }
    }
  }

  const _togglePasswordVisibility = async () => {
    if (inputType === DataType.Password) {
      setBtnImage(ShowVisibility);
      setInputType(DataType.Text);
    }
    if (inputType === DataType.Text) {
      setBtnImage(HideVisibility);
      setInputType(DataType.Password)
    }
  }

  const navigateToReg = async () => navigate(CommonPages.EnterEmail);

  useEffect(() => {
    let token = SessionStorage.getItem(SessionStorageKeys.SessionToken);
    if (token) {
      navigate(CommonPages.dashboard);
    }
  }, [])

  return (
    <div className="main-login">
      {isLoading && <LoadingSpinner />}
      <div className="left-part">
        <div className="first-div"><MappixDesign /></div>
      </div>
      <div className="right-part">
        <div className="first-div">
          <div>
            <p className="welcome-title">{Common.Welcome}</p>
            <p className="welcome-subtitle">{Common.PleaseEnterYourEmailAddressAndPassword}</p>
          </div>
          <Formik initialValues={{ email: "", password: "" }} onSubmit={(values, { setSubmitting }) => {
            setSubmitting(true);
            const formData = {
              email: values.email.trim().toLowerCase(),
              password: values.password
            }; _userLogin(formData);
          }}>
            {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
              <Form onSubmit={handleSubmit}>
                <Form.Group>
                  <div>
                    <Form.Control id="userNamePlaceholder" type="email" name="email" placeholder={Common.EmailExample} onChange={handleChange} onBlur={handleBlur} value={values.email} className={touched.email && errors.email ? "user_email" : "user_email_active"} ref={emailRef} autoComplete="off" />
                    <img src={Account} alt="Acc" className="AcoountLogo" />
                  </div>
                  {touched.email && errors.email ? (<p className="error-message">{errors.email}</p>) : <p>{""}</p>}
                </Form.Group>
                <Form.Group>
                  <div>
                    <Form.Control type={inputType} name="password" id="userPasswordPlaceholder" placeholder={Common.Password_} onChange={handleChange} onBlur={handleBlur} value={values.password} className={touched.password && errors.password ? "user_password marginClass" : "user_password_active marginClass"} ref={passwordRef} autoComplete="off" />
                    <span onClick={_togglePasswordVisibility} role="button" onKeyDown={(e) => { e.key === "Enter" && _togglePasswordVisibility() }} tabIndex={0}>
                      <img src={btnImage} alt="Acc" className="visibleLogo" />
                    </span>
                  </div>
                  {touched.password && errors.password ? (<p className="error-message">{errors.password}</p>) : <p>{""}</p>}
                </Form.Group>
                <div className="login-submit-button-div marginClass">
                  <button type="submit" className="submit-button">Login
                    <img src={RightArrow} alt="Submit" type="image" width="65px" className="login-icon" />
                  </button>
                  <button className="for-pass" onClick={navigateToReg}>
                    {Common.ForgotYourPassword}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </div>
        <div className="second-div"><img src={HexagonCharacter} className="hexagon-logo" alt="hexagon-character"></img></div>
      </div>
    </div>
  );
}

export { Login };